import React from "react";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "../../../../ui/dialog";

type RedirectingToPaymentsDialogProps = {
  isOpen: boolean;
  currencySymbol: string;
  amount: number;
};

const RedirectingToPaymentsDialog = ({
  isOpen,
  currencySymbol,
  amount
}: RedirectingToPaymentsDialogProps) => {
  return (
    <Dialog open={isOpen}>
      <DialogContent
        showCloseButton={false}
        className="max-w-xs flex flex-col items-center justify-center"
      >
        <DialogHeader className="text-center w-full">
          <DialogTitle className="text-center w-full">
            Redirecting to Payments
          </DialogTitle>
          <DialogDescription className="text-center w-full">
            Opening payment form for {currencySymbol}
            {amount.toFixed(2)}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center py-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RedirectingToPaymentsDialog;
